var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4004 7.40002H11.4004V11.4H7.40039V13.4H11.4004V17.4H13.4004V13.4H17.4004V11.4H13.4004V7.40002ZM12.4004 2.40002C6.88039 2.40002 2.40039 6.88002 2.40039 12.4C2.40039 17.92 6.88039 22.4 12.4004 22.4C17.9204 22.4 22.4004 17.92 22.4004 12.4C22.4004 6.88002 17.9204 2.40002 12.4004 2.40002ZM12.4004 20.4C7.99039 20.4 4.40039 16.81 4.40039 12.4C4.40039 7.99002 7.99039 4.40002 12.4004 4.40002C16.8104 4.40002 20.4004 7.99002 20.4004 12.4C20.4004 16.81 16.8104 20.4 12.4004 20.4Z",
    fill: "url(#paint0_linear_18550_301756)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18550_301756",
    x1: 19.0005,
    y1: -0.499878,
    x2: 4.50049,
    y2: 24.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18397A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6C9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/InviteIcon.a72ceeee441c3b73ca9e9f72cfad5f44.svg";
export { ForwardRef as ReactComponent };